/**
 * @generated SignedSource<<82ebd8b8c485b75079d25c08829e68fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteTreeInput = {
  clientMutationId?: string | null | undefined;
  rootId: string;
};
export type ActionColumn_DeleteUnpublishedTreeMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteTreeInput;
};
export type ActionColumn_DeleteUnpublishedTreeMutation$data = {
  readonly Admin: {
    readonly LearnV2: {
      readonly deleteTree: {
        readonly deletedRootId: string;
      } | null | undefined;
    };
  };
};
export type ActionColumn_DeleteUnpublishedTreeMutation = {
  response: ActionColumn_DeleteUnpublishedTreeMutation$data;
  variables: ActionColumn_DeleteUnpublishedTreeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedRootId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionColumn_DeleteUnpublishedTreeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "LearnV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteTreePayload",
                "kind": "LinkedField",
                "name": "deleteTree",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActionColumn_DeleteUnpublishedTreeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "LearnV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteTreePayload",
                "kind": "LinkedField",
                "name": "deleteTree",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedRootId",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ccac00f347516eac524ea34084c34025",
    "id": null,
    "metadata": {},
    "name": "ActionColumn_DeleteUnpublishedTreeMutation",
    "operationKind": "mutation",
    "text": "mutation ActionColumn_DeleteUnpublishedTreeMutation(\n  $input: DeleteTreeInput!\n) {\n  Admin {\n    LearnV2 {\n      deleteTree(input: $input) {\n        deletedRootId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "db2bac167e09d7918871816fae94a506";

export default node;
